import { useState } from "react";
import SVG from "../../../Components/SVG";
import Custom from "../../../Components/Buttons/Custom";
import { toJalaliDateTime } from "../../../helper/toJalaliDateTime";
import TradeHistoryGrid from "./TradeHistoryGrid";
import TradeHistoryTable from "./TradeHistoryTable";

const formatPriceTrimmed = (value) => {
  const num = Number(value);
  return Number.isFinite(num)
    ? num.toLocaleString("en-US", { maximumFractionDigits: 18 })
    : "-";
};

const formatMoney = (value) => {
  const num = Number(value);
  return Number.isFinite(num)
    ? Number(num.toFixed(2)).toLocaleString()
    : "-";
};

export default function TradeHistory({ accountData, accLoading }) {
  const [activeFilter] = useState(() => {
    if (typeof window !== "undefined" && window.innerWidth >= 480) {
      return [false, true];
    }
    return [true, false];
  });

  const handleDownload = () => {
    if (!accountData?.trades?.length || typeof document === "undefined") {
      return;
    }

    const headers = [
      "کد معامله",
      "زمان باز شدن",
      "قیمت باز شدن",
      "زمان بسته شدن",
      "قیمت بسته شدن",
      "سود",
      "حجم",
      "کمیسیون",
      "سود خالص",
      "نماد",
      "نوع معامله",
    ];

    const escapeCSV = (value) => {
      if (value === null || value === undefined) return "";
      const stringValue = String(value);
      return /[",\n]/.test(stringValue)
        ? `"${stringValue.replace(/"/g, '""')}"`
        : stringValue;
    };

    const rows = accountData.trades.map((trade) => {
      const pnl = Number(trade.profit_loss);
      const formattedPnl =
        pnl >= 0 ? `$${formatMoney(pnl)}` : `-$${formatMoney(Math.abs(pnl))}`;

      return [
        trade.id,
        toJalaliDateTime(trade.opened_at),
        `$${formatPriceTrimmed(trade.entry_price)}`,
        toJalaliDateTime(trade.closed_at),
        `$${formatPriceTrimmed(trade.exit_price)}`,
        formattedPnl,
        `${formatMoney(trade.margin_usdt)} USDT`,
        "$0",
        formattedPnl,
        trade.symbol?.toUpperCase?.() ?? "",
        trade.side === "long" ? "Buy" : "Sell",
      ]
        .map(escapeCSV)
        .join(",");
    });

    const csvContent = [headers.join(","), ...rows].join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = `trade-history-${
      accountData?.accountCode ??
      accountData?.account?.id ??
      accountData?.id ??
      "export"
    }.csv`;
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="w-full p-5 flex flex-col gap-5 rounded-2xl bg-zi-bg2-light dark:bg-zi-bg2-dark">
      <div className="flex justify-between items-center">
        <h3 className="flex gap-2.5 items-center">
          <SVG
            name="archive"
            classname="size-5 stroke-zi-text-light dark:stroke-zi-text-dark"
          />
          <p className="text-lg font-medium text-zi-text-light dark:text-zi-text-dark">
            تاریخچه معاملات
          </p>
        </h3>
        <Custom
          onClick={handleDownload}
          text="دانلود CSV"
          className="bg-zi-buttonbg-primary !px-2.5 !py-1.5 mb:!px-5 mb:!py-2 !rounded-full text-xs mb:text-sm text-zi-text-dark hocus:opacity-85"
        />
      </div>

      {activeFilter[0] && (
        <TradeHistoryGrid accountData={accountData} accLoading={accLoading} />
      )}
      {activeFilter[1] && (
        <TradeHistoryTable accountData={accountData} accLoading={accLoading} />
      )}
    </div>
  );
}
